import axios from "axios";
import React from "react";
import constants from "../utilities/constants.json";
import { useDispatch, useSelector } from "react-redux";
import { SetSettings } from "../actions";
import { useSetUnderMaintenance } from "./useMaintenanceStatus";

const apiUrl = constants.server + "get_settings";

function useInitializeSettings() {
  const dispatch = useDispatch();
  /** @type {SettingsState} */
  const settings = useSelector((state) => state.settings);

  const { setSiteUnderMaintenance } = useSetUnderMaintenance();

  React.useEffect(() => {
    const fetchSettings = async () => {
      try {
        const response = await axios.get(apiUrl);
        if (response.data.status === 1) dispatch(SetSettings(response.data));
        else if (response.data.status === 103)
          setSiteUnderMaintenance()
          
      } catch (error) {
        console.error("Error fetching settings:", error);
      }
    };

    fetchSettings();
  }, []);

  const isTournamentOver = React.useMemo(()=> (settings?.wrap_up_date ? new Date(settings.wrap_up_date) < new Date() : false), [settings?.wrap_up_date]);

  return { isTournamentOver, settings };
}

/**
 * @typedef {Object} MatchDate
 * @property {string} date
 * @property {string} day
 * @property {string} day
 * @property {string} start_date
 * @property {string} end_date
 * @property {string} group_label
 * @property {"active" | "inactive"} match_status
 */

/**
 * @typedef {Object} SettingsState
 * @property {number} status
 * @property {string} message
 * @property {string} wc_start_date
 * @property {string} wc_end_date
 * @property {string} wrap_up_date
 * @property {string} current_group_label
 * @property {number} total_players
 * @property {MatchDate[]} match_dates
 */

/**
 * @typedef {Object} RootState
 * @property {SettingsState} settings
 */

function useSettings() {
  /** @type {SettingsState} */
  const settings = useSelector((state) => state.settings);

  return settings;
}

export { useInitializeSettings ,useSettings };
